import PropTypes from 'prop-types';

export const defaultProps = {
  onClick: PropTypes.func,
};

export const propTypes = {
  onClick: () => {},
};
